import { Culture } from '../../types';

export const yupik: Culture = {
  name: 'Yup\'ik',
  languageFamily: 'Eskimo-Aleut',
  terms: [
    {
      word: 'Cauyaq',
      phonetic: 'chow-yahk',
      description: 'Yup\'ik word for "drum."'
    },
    {
      word: 'Ellam Yua',
      phonetic: 'el-lahm yoo-ah',
      description: 'Yup\'ik term for the spirit of the universe or everything.'
    },
    {
      word: 'Qaspeq',
      phonetic: 'kah-spek',
      description: 'Yup\'ik word for a traditional hooded garment, also called a "kuspuk."'
    },
    {
      word: 'Ulu',
      phonetic: 'oo-loo',
      description: 'Yup\'ik word for a traditional woman\'s knife used for food preparation.'
    },
    {
      word: 'Yuraq',
      phonetic: 'yoo-rahk',
      description: 'Yup\'ik term for a traditional dance or ceremony.'
    }
  ]
};